import * as Yup from "yup";

/**
 * Schema base de uma série/exercício — aceita campos de todos os tipos.
 * Campos não utilizados em um tipo ficam nullable.
 */
const setSchema = Yup.object().shape({
    // Comum
    reps: Yup.mixed().nullable(),
    description: Yup.string().nullable(),

    // Natação
    distance: Yup.mixed().nullable(),
    setType: Yup.string().nullable(),
    style: Yup.string().nullable(),
    intensity: Yup.string().nullable(),
    interval: Yup.string().nullable(),
    equipment: Yup.string().nullable(),
    technicalFocus: Yup.string().nullable(),

    // Musculação
    exercise: Yup.string().nullable(),
    sets: Yup.mixed().nullable(),
    load: Yup.string().nullable(),
    muscleGroup: Yup.string().nullable(),
    rest: Yup.string().nullable(),

    // Corrida
    pace: Yup.string().nullable(),
    type: Yup.string().nullable(),

    // WOD
    time: Yup.string().nullable(),
});

/**
 * Schema de um bloco de treino.
 */
const blockSchema = Yup.object().shape({
    name: Yup.string().required("Nome do bloco é obrigatório"),
    workoutType: Yup.string().oneOf(["swimming", "strength", "running", "wod"]).required().default("strength"),
    method: Yup.string().nullable().default("normal"),
    description: Yup.string().nullable(),
    sets: Yup.array().of(setSchema).default([]),
});

/**
 * Schema de uma sessão de treino (array sessions[]).
 * Campo canônico: sessions. O campo "workouts" foi removido.
 */
const workoutSessionSchema = Yup.object().shape({
    name: Yup.string().required("Nome da sessão é obrigatório"),
    sessionType: Yup.string().oneOf(["swimming", "strength", "running", "wod"]).required().default("strength"),
    blocks: Yup.array().of(blockSchema).default([]),
});

/**
 * workoutTemplateSchema
 * Validação para o formulário de Template de Treino.
 */
export const workoutTemplateSchema = Yup.object().shape({
    title: Yup.string()
        .min(2, "Título muito curto")
        .required("O título é obrigatório"),
    description: Yup.string().nullable(),
    workoutType: Yup.string().oneOf(["swimming", "strength", "running", "wod"]).default("strength"),
    objective: Yup.string().nullable(),
    level: Yup.string().nullable(),
    tags: Yup.array().of(Yup.string()).default([]),
    isSingleDay: Yup.boolean().default(false),
    weeklyFrequency: Yup.number().min(1).max(7).default(3),
    totalWeeks: Yup.number().min(1).max(52).nullable(),
    sessions: Yup.array().of(workoutSessionSchema).default([]),
});

/**
 * workoutPrescriptionSchema
 * Validação para o formulário de Prescrição de Treino.
 */
export const workoutPrescriptionSchema = Yup.object().shape({
    title: Yup.string()
        .min(2, "Título muito curto")
        .required("O título é obrigatório"),
    isSingleDay: Yup.boolean().default(false),
    weeklyFrequency: Yup.number().min(1).max(7).default(3),
    sessions: Yup.array().of(workoutSessionSchema).default([]),
});
